// Vivid tune-type badges.
const TYPE_STYLES = {
  reel: { bg: "#FF3366", text: "#fff" },
  jig: { bg: "#FFB800", text: "#2d2824" },
  hornpipe: { bg: "#00C4B5", text: "#fff" },
  "slip jig": { bg: "#8A2BE2", text: "#fff" },
  polka: { bg: "#FF6B00", text: "#fff" },
  slide: { bg: "#06B6D4", text: "#fff" },
  waltz: { bg: "#4CAF50", text: "#fff" },
  barndance: { bg: "#EC4899", text: "#fff" },
  strathspey: { bg: "#7C3AED", text: "#fff" },
  "three-two": { bg: "#0EA5E9", text: "#fff" },
  mazurka: { bg: "#F43F5E", text: "#fff" },
  march: { bg: "#16A34A", text: "#fff" },
};
const DEFAULT_STYLE = { bg: "#9C27B0", text: "#fff" };

export const typeStyle = (type) => TYPE_STYLES[type] || DEFAULT_STYLE;

export const TuneTypeBadge = ({ type, className = "", size = "md" }) => {
  const style = TYPE_STYLES[type] || DEFAULT_STYLE;
  const sizes = {
    sm: "px-2.5 py-0.5 text-[10px]",
    md: "px-3.5 py-1 text-xs",
    lg: "px-4 py-1.5 text-sm",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full font-extrabold uppercase tracking-wider ${sizes[size]} ${className}`}
      style={{ backgroundColor: style.bg, color: style.text }}
      data-testid="tune-type-badge"
    >
      {type}
    </span>
  );
};
